<template>
  <div class="wrapper">
    <div class="title-section">
      <h1 class="type-title">{{ $t('footscan.arch_type__title') }}</h1>
      <h2 class="type-name text-purple-gradient">{{ archType.name }}</h2>
    </div>
    <div class="main-img-wrapper">
      <img :src="archType.img" :alt="archType.name" />
    </div>
    <div class="type-summary" v-html="archType.summary"></div>
    <div class="alt-images">
      <img :src="archType.imgSide" :alt="archType.name" />
      <img :src="archType.imgFootprint" :alt="archType.name" />
    </div>
    <div class="type-desc mb-4" v-html="archType.description"></div>
  </div>
</template>

<script>
import imgArchHigh from '@/assets/FootScan/arch-high.svg';
import imgArchNormal from '@/assets/FootScan/arch-normal.svg';
import imgArchLow from '@/assets/FootScan/arch-low.svg';
import imgSideArchHigh from '@/assets/FootScan/side-arch-high.svg';
import imgSideArchNormal from '@/assets/FootScan/side-arch-normal.svg';
import imgSideArchLow from '@/assets/FootScan/side-arch-low.svg';
import imgFootprintHigh from '@/assets/FootScan/footprint-arch-high.svg';
import imgFootprintNormal from '@/assets/FootScan/footprint-arch-normal.svg';
import imgFootprintLow from '@/assets/FootScan/footprint-arch-low.svg';

export default {
  name: 'FootType',
  props: {
    measurement: {
      type: Object,
      default: () => ({
        left: { value: 1 },
        right: { value: 1 },
      }),
    },
  },
  computed: {
    typeIndex() {
      const { left, right } = this.measurement;
      const value = Math.max(left.value, right.value);
      if (value > 1.2) return 0;
      if (value <= 0.2) return 2;
      return 1;
    },
    archType() {
      const DATA = [
        {
          img: imgArchHigh,
          name: this.$i18n.t('footscan.arch_type__high'),
          summary: this.$i18n.t('footscan.arch_type__summary_high'),
          description: this.$i18n.t('footscan.arch_type__desc_high'),
          imgSide: imgSideArchHigh,
          imgFootprint: imgFootprintHigh,
        },
        {
          img: imgArchNormal,
          name: this.$i18n.t('footscan.arch_type__normal'),
          summary: this.$i18n.t('footscan.arch_type__summary_normal'),
          description: this.$i18n.t('footscan.arch_type__desc_normal'),
          imgSide: imgSideArchNormal,
          imgFootprint: imgFootprintNormal,
        },
        {
          img: imgArchLow,
          name: this.$i18n.t('footscan.arch_type__low'),
          summary: this.$i18n.t('footscan.arch_type__summary_low'),
          description: this.$i18n.t('footscan.arch_type__desc_low'),
          imgSide: imgSideArchLow,
          imgFootprint: imgFootprintLow,
        },
      ];
      return DATA[this.typeIndex];
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  @apply relative flex flex-1 flex-col px-5 text-left;
  letter-spacing: 0;
  font-style: normal;
}
.type-title {
  @apply mt-5;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
}
.type-name {
  @apply my-2;
  font-size: 24px;
  font-weight: 600;
  line-height: 36px;
}
.main-img-wrapper {
  @apply px-10 mt-4;
  img {
    @apply w-full;
  }
}
.type-summary {
  @apply my-5;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
}
.alt-images {
  @apply my-5 flex flex-row items-center justify-around;
}
.type-desc {
  @apply mt-5;
  font-size: 12px;
  font-weight: 400;
  line-height: 34px;
  color: #595959;
}
</style>
